import gql from 'graphql-tag'

export const GET_USERS = gql`
query Users {
  users {
    isSuccessful
    message
    users {
      lastLogin
      fullname
      email
      canLogin
      userId
      isEmployee
      username
      groups {
        id
        name
      }
      position {
        name
        unitName
        departmentName
      }
    }
  }
}
`

export const GET_USER = gql`
query User($input: GetEmployeeUserInput!) {
  user(input: $input) {
    isSuccessful
    message
    user {lastLogin
      fullname
      email
      canLogin
      userId
      isEmployee
      groups {
        id
        name
      }
      position {
        name
        unitName
        departmentName
      }
    }
  }
}
`

export const GET_USER_GROUPS = gql`
query Ugroups {
  ugroups {
    isSuccessful
    message
    ugroups {
      id
      name
    }
  }
}
`

export const UPDATE_USER = gql`
mutation UpdateUser($input: UpdateEmployeeUserInput!) {
  updateUser(input: $input) {
    isSuccessful
    message
    user {
      userId
    }
  }
}
`
